module.exports = __webpack_public_path__ + "images/861df8f29619add3a077e79b91a64be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/sports_travel_logo.png
// module id = 1276
// module chunks = 0